// frontend/src/hooks/usePageLogger.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../services/activityService';

const usePageLogger = () => {
    const location = useLocation();

    useEffect(() => {
        // Every time the location.pathname changes, call our logging function.
        logPageView(location.pathname);
    }, [location.pathname]); // The hook re-runs only when the pathname changes
};

export default usePageLogger;